/**
 * Admin org management store for the Reviews SaaS app.
 *
 * Super-admins can switch between orgs. The selected org_id is persisted
 * in localStorage so a page refresh keeps the selection. When a non-null
 * selectedOrgId is present, the API client injects X-Tenant-Id on every
 * request, overriding the hostname-resolved org on the backend.
 *
 * @module lib/admin
 */

import { createAppStore } from "@plerity/dashboard-shared/stores";
import { persist } from "zustand/middleware";

interface AdminState {
  /** Super-admin override org_id — null means use hostname-resolved org */
  selectedOrgId: number | null;
  setSelectedOrgId: (orgId: number | null) => void;
  reset: () => void;
}

export const useAdminStore = createAppStore<AdminState>(
  "reviews-admin",
  persist(
    (set) => ({
      selectedOrgId: null,
      setSelectedOrgId: (orgId) => set({ selectedOrgId: orgId }),
      reset: () => set({ selectedOrgId: null }),
    }),
    {
      name: "reviews-admin-org",
      partialize: (state) => ({ selectedOrgId: state.selectedOrgId }),
    }
  )
);
